import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaEnvelope,
  FaPhoneAlt,
  FaStar,
  FaPaperPlane,
  FaCompass
} from 'react-icons/fa';

import './ContactSection.css';

const ContactSection = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      const response = await fetch(
        "http://localhost:5000/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }
      );
      
      const data = await response.json();
      
      alert(data.message);
      setFormData({
        name: '',
        email: '',
        phone: ''
      });

    } catch (error) {

      alert("Something Went Wrong");

    }

    setLoading(false);
  };

  return (
    <section id="contact-section" className="holiday-hero-section">

      {/* Overlay */}
      <div className="main-overlay"></div>

      <div className="container-wrapper">

        <div className="hero-content-grid">

          {/* LEFT SIDE */}
          <motion.div
            className="hero-text-area"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false }}
          >

            <h1 className="hero-main-heading">
              Escape to the <br />
              <span className="accent-orange">
                Majestic Mountains
              </span>
            </h1>

            <p className="hero-sub-description">
              Experience premium stays and expert-guided tours.
              Chandrama Holidays brings you the most trusted
              Himalayan escape for unforgettable memories.
            </p>

            <div className="trust-indicators">

              <span className="indicator">
                <FaStar className="star" />
                4.9 Customer Rating
              </span>

              <span className="indicator">
                <FaCompass className="compass" />
                Verified Routes
              </span>

            </div>

            <div className="quick-contact-info">

              <p>
                <FaEnvelope className="c-icon" />
                chandramaholidays12@gmail.com
              </p>

              <p>
                <FaPhoneAlt className="c-icon" />
                +91 9923562524 | 9325779623
              </p>

            </div>

          </motion.div>

          {/* RIGHT SIDE FORM */}
          <motion.div
            className="hero-form-area"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
          >

            <div className="glass-form-container">

              <div className="form-top-circle">
                <FaPaperPlane className="plane-icon" />
              </div>

              <h2 className="form-heading-title">
                Book Your Trip
              </h2>

              <p className="form-heading-subtitle">
                Fill the form to get an instant callback.
              </p>

              <form
                className="booking-form-compact"
                onSubmit={handleSubmit}
              >

                {/* NAME */}
                <div className="custom-input-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                {/* EMAIL */}
                <div className="custom-input-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                {/* PHONE */}
                <div className="custom-input-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Mobile Number"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                {/* BUTTON */}
                <button
                  type="submit"
                  className="cta-orange-button"
                  disabled={loading}
                >

                  {
                    loading
                      ? "Sending..."
                      : "Submit Enquiry"
                  }

                  <FaPaperPlane className="btn-small-icon" />

                </button>

              </form>

            </div>

          </motion.div>

        </div>

      </div>

    </section>
  );
};

export default ContactSection;